import {inject, Injectable} from '@angular/core';
import {Auth, onAuthStateChanged, User} from '@firebase/auth';
import {FIREBASE_AUTH} from '../app/config/module.di.tokens';
import {Observable, shareReplay} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private auth = inject<Auth>(FIREBASE_AUTH);

  readonly user$ = new Observable<User | null>((obs) =>
    onAuthStateChanged(this.auth, user => obs.next(user)),
  ).pipe(
    shareReplay({ bufferSize: 1, refCount: false }),
  );
}
